import angular from 'angular';

import CalendarSideBarComponent from './calendar-side-bar.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-side-bar', [])
    .component(CalendarSideBarComponent.selector, CalendarSideBarComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-side-bar/index.js